import React, { useContext } from 'react'
import { ChartCardStyles, DoughnutChartsStyles } from './Style'
import { assessmentsHooks } from '.'
import { DoughnutChart } from 'pages/Dashboard'
import { Space } from 'styles/GlobalStyle'
import { ratingColors4, ratingListLabel } from 'keys/rating'

const doughnutCharts = () => {
    const charts = assessmentsHooks.useCharts()

    return (
        <DoughnutChartsStyles>
            <div className='chart-cards'>
                {charts.map((chart, index) =>
                    <div className='chart-card-styles' key={index}>
                        <div className='card-header'>
                            <div className='card-label'>{chart.label}</div>
                        </div>
                        <Space />
                        <div className='card-content'>
                            <div className='doughnut-chart'>
                                <DoughnutChart loading={chart.chart.isFetching} data={chart.chart.data?.percent} />
                            </div>
                            <div className='chart-list'>
                                {chart.chart.data?.count?.map((item, index) =>
                                    <div className='chart-list-item'>
                                        <div className='chart-list-square' style={{ background: ratingColors4[index] }}></div>
                                        <div className='chart-list-label'>{` ${item.toFixed(0)} תלמידים`}{" "}{ratingListLabel[index]}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </DoughnutChartsStyles>
    )
}

export default doughnutCharts